import { render, staticRenderFns } from "./PackageConfigList.html?vue&type=template&id=76b372c1&"
import script from "./PackageConfigList.vue?vue&type=script&lang=js&"
export * from "./PackageConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports